<style>
    .is-invalid-button {
        border: 1px solid#D33638;
    }
</style>

<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { SlideEditor } from '../methods/SlideEditor.js';
    import { SlideEditor as SlideEditor2 } from '../methods/SlideEditor2.js';
    import { isPlainObject } from '../methods/isPlainObject.js';
    import { isEmpty } from '../methods/isEmpty.js';
    import { submitButtonControl } from '../methods/submitButtonControl.js';

    // @ts-ignore
    const tinymce = window.tinymce;
    // @ts-ignore
    const MTRichTextEditor = window.MTRichTextEditor


    let { mtappVars = $bindable(), id, storage = $bindable(), storageKey, handle, fieldBlock } = $props();

    if (fieldBlock.type === 'splitField' && !isPlainObject(storage[storageKey])) {
        storage[storageKey] = {};
        fieldBlock.options.forEach((option) => {
            storage[storageKey][option.key] = '';
        });
    }

    let validationEnabled = $state(false);
    let hasError = $state(false);
    let hasRequiredError = $state(false);
    let hasValidationError = $state(false);

    function validateField(event, _id = id, value = storage[storageKey], option = null) {
        validationEnabled = true;
        if (fieldBlock.required) {
            // 必須項目のエラーチェック
            hasRequiredError = isEmpty(value) && validationEnabled;
        } else {
            // 必須でない場合はエラーをクリア
            hasRequiredError = false;
        }
        if (fieldBlock.type === 'splitField' && option && option.attributes?.pattern) {
            const pattern = new RegExp(option.attributes.pattern);
            hasValidationError = !pattern.test(value);
        } else if (fieldBlock.attributes?.pattern) {
            const pattern = new RegExp(fieldBlock.attributes.pattern);
            hasValidationError = !pattern.test(value);
        }
        hasError = hasRequiredError || hasValidationError;
        if (hasError) {
            mtappVars.__system.multiFieldErrors[_id] = 1;
            mtappVars.__system.submitButtonControlHasError = true;
            submitButtonControl('hasError');
        } else {
            delete mtappVars.__system.multiFieldErrors[_id];
        }
        if (isEmpty(mtappVars.__system.multiFieldErrors)) {
            submitButtonControl('submittable');
        }
    }

    function inputNumber() {
        if (typeof fieldBlock.emptyAs !== 'undefined') {
            if (isEmpty(storage[storageKey]) || storage[storageKey] === 'null') {
                storage[storageKey] = fieldBlock.emptyAs;
            }
        }
        if (fieldBlock.asString) {
            storage[storageKey] = String(storage[storageKey]);
        }
        triggerInputChange();
    }

    const dispatch = createEventDispatcher();
    function triggerInputChange() {
        dispatch('inputchange');
    }

    onMount(() => {
        if (fieldBlock.type === 'splitField') {
            fieldBlock.options.forEach((option) => {
                validateField(null, id + '-' + option.key);
            });
        } else {
            validateField();
        }

        if (fieldBlock.type === 'tinymce') {
            const options = fieldBlock.options || {};
            const preset = fieldBlock.preset || '';
            // スライドエディタを初期化

            if (MTRichTextEditor) {
                new SlideEditor2(id, options, preset, (content) => {
                    storage[storageKey] = content;
                    validateField();
                    triggerInputChange();
                });
            } else if (tinymce) {
                new SlideEditor(id, options, preset, (content) => {
                    storage[storageKey] = content;
                    validateField();
                    triggerInputChange();
                });
            }
        }
    });
</script>

<div data-handle={handle}>
    {#if ['text', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(fieldBlock.type)}
        <input
            type="text"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            size={fieldBlock.attributes?.size}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'email'}
        <input
            type="email"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            multiple={fieldBlock.attributes?.multiple}
            size={fieldBlock.attributes?.size}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'url'}
        <input
            type="url"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            size={fieldBlock.attributes?.size}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'tel'}
        <input
            type="tel"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            size={fieldBlock.attributes?.size}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'password'}
        <input
            type="password"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            size={fieldBlock.attributes?.size}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'number'}
        <input
            type="number"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            readonly={fieldBlock.attributes?.readonly}
            title={fieldBlock.attributes?.title}
            step={fieldBlock.attributes?.step}
            min={fieldBlock.attributes?.min}
            max={fieldBlock.attributes?.max}
            inputmode={fieldBlock.attributes?.inputmode}
            onblur={validateField}
            oninput={inputNumber} />
    {:else if fieldBlock.type === 'search'}
        <input
            type="search"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            pattern={fieldBlock.attributes?.pattern}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            size={fieldBlock.attributes?.size}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onchange={validateField}
            oninput={triggerInputChange} />
    {:else if ['date', 'datepicker'].includes(fieldBlock.type)}
        <input
            type="date"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            readonly={fieldBlock.attributes?.readonly}
            title={fieldBlock.attributes?.title}
            step={fieldBlock.attributes?.step}
            min={fieldBlock.attributes?.min}
            max={fieldBlock.attributes?.max}
            onchange={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'time'}
        <input
            type="time"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            readonly={fieldBlock.attributes?.readonly}
            title={fieldBlock.attributes?.title}
            step={fieldBlock.attributes?.step}
            min={fieldBlock.attributes?.min}
            max={fieldBlock.attributes?.max}
            onchange={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'color'}
        <input
            type="color"
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            readonly={fieldBlock.attributes?.readonly}
            title={fieldBlock.attributes?.title}
            onblur={validateField}
            oninput={triggerInputChange} />
    {:else if fieldBlock.type === 'splitField'}
        <div class="d-md-flex gap-3">
            {#each fieldBlock.options as option}
                <div class="flex-fill">
                    {#if option.label}
                        <label class="form-label" for={id + '-' + option.key}>{option.label}</label>
                    {/if}
                    <input
                        type={option.type || 'text'}
                        class="form-control"
                        id={id + '-' + option.key}
                        placeholder={option.placeholder || option.attributes?.placeholder || ''}
                        class:is-invalid={fieldBlock.required && isEmpty(storage[storageKey][option.key]) && validationEnabled}
                        bind:value={storage[storageKey][option.key]}
                        onblur={(event) => {
                            validateField(event, id + '-' + option.key, storage[storageKey][option.key], option);
                        }}
                        oninput={() => {
                            if (typeof option.emptyAs !== 'undefined') {
                                if (isEmpty(storage[storageKey][option.key]) || storage[storageKey][option.key] === 'null') {
                                    storage[storageKey][option.key] = option.emptyAs;
                                }
                            }
                            if (option.type === 'number' && option.asString) {
                                storage[storageKey][option.key] = String(storage[storageKey][option.key]);
                            }
                            triggerInputChange();
                        }} />
                    {#if fieldBlock.required && isEmpty(storage[storageKey][option.key]) && validationEnabled}
                        <span class="text-danger fw-bold">{mtappVars.translate['This field is required']}</span>
                    {/if}
                    {#if option.attributes?.pattern && option.attributes?.title && !new RegExp(option.attributes.pattern).test(storage[storageKey][option.key]) && validationEnabled}
                        <span class="text-danger fw-bold">{option.attributes?.title}</span>
                    {/if}
                </div>
            {/each}
        </div>
    {:else if fieldBlock.type === 'textarea'}
        <textarea
            class="form-control"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange}></textarea>
    {:else if fieldBlock.type === 'code'}
        <textarea
            class="form-control font-monospace"
            class:is-invalid={hasError}
            id={id}
            bind:value={storage[storageKey]}
            placeholder={fieldBlock.attributes?.placeholder}
            readonly={fieldBlock.attributes?.readonly}
            maxlength={fieldBlock.attributes?.maxlength}
            minlength={fieldBlock.attributes?.minlength}
            title={fieldBlock.attributes?.title}
            autocomplete={fieldBlock.attributes?.autocomplete}
            inputmode={fieldBlock.attributes?.inputmode}
            spellcheck={fieldBlock.attributes?.spellcheck}
            onblur={validateField}
            oninput={triggerInputChange}></textarea>
    {:else if fieldBlock.type === 'tinymce'}
        <textarea
            class="form-control"
            id={id}
            bind:value={storage[storageKey]}
            oninput={() => {
                validateField();
                triggerInputChange();
            }}></textarea>
        <div id={id + '-view'} class="mtapp-slide-editor-viewer">{@html storage[storageKey]}</div>
        <button id={id + '-button'} type="button" class="btn btn-default mt-3" class:is-invalid-button={hasError}
            >{mtappVars.translate['Edit']}</button>
    {:else if fieldBlock.type === 'select'}
        <select
            bind:value={storage[storageKey]}
            class="form-select"
            class:is-invalid={hasError}
            id={id}
            onchange={() => {
                validateField();
                triggerInputChange();
            }}>
            {#if !fieldBlock.removeEmptyOption}
                <option value="">{mtappVars.translate['Please select...']}</option>
            {/if}
            {#each fieldBlock.options as option}
                <option value={option.data}>{option.label}</option>
            {/each}
        </select>
    {:else if fieldBlock.type === 'select-multiple'}
        <select
            bind:value={storage[storageKey]}
            class="form-select"
            class:is-invalid={hasError}
            id={id}
            multiple
            onchange={() => {
                validateField();
                triggerInputChange();
            }}>
            {#each fieldBlock.options as option}
                <option value={option.data}>{option.label}</option>
            {/each}
        </select>
    {:else if fieldBlock.type === 'checkbox' && fieldBlock.options.length > 1}
        {#each fieldBlock.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-checkbox">
                <input
                    type="checkbox"
                    class="form-check-input"
                    class:is-invalid={hasError}
                    value={option.data}
                    id={[id, optionIdx].join('-')}
                    bind:group={storage[storageKey]}
                    onchange={() => {
                        validateField();
                        triggerInputChange();
                    }} />
                <label class="form-check-label" for={[id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {:else if fieldBlock.type === 'checkbox'}
        {#each fieldBlock.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-checkbox">
                <input
                    type="checkbox"
                    class="form-check-input"
                    class:is-invalid={hasError}
                    value={option.data}
                    id={[id, optionIdx].join('-')}
                    bind:checked={storage[storageKey]}
                    onchange={() => {
                        validateField();
                        triggerInputChange();
                    }} />
                <label class="form-check-label" for={[id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {:else if fieldBlock.type === 'radio'}
        {#each fieldBlock.options as option, optionIdx}
            <div class="form-check form-check-inline mtapp-mf-field-radio">
                <input
                    type="radio"
                    class="form-check-input"
                    class:is-invalid={hasError}
                    value={option.data}
                    id={[id, optionIdx].join('-')}
                    name={id}
                    bind:group={storage[storageKey]}
                    onchange={() => {
                        validateField();
                        triggerInputChange();
                    }} />
                <label class="form-check-label" for={[id, optionIdx].join('-')}>{option.label}</label>
            </div>
        {/each}
    {/if}
    {#if fieldBlock.required && hasRequiredError && fieldBlock.type !== 'splitField'}
        <span class="text-danger fw-bold">{mtappVars.translate['This field is required']}</span>
    {/if}
    {#if fieldBlock.attributes?.pattern && fieldBlock.attributes?.title && hasValidationError && fieldBlock.type !== 'splitField'}
        <span class="text-danger fw-bold">{fieldBlock.attributes.title}</span>
    {/if}
</div>
